import * as styles from './ClaimCallout.css';
import { BOOK_A_DEMO_HREF, CTA_IMAGE } from './content';
import { LandingButton } from './LandingButton';

interface ClaimCalloutProps {
  claimHref: string;
  ctaLabel: string;
  onClaimClick?: () => void;
}

export const ClaimCallout = ({ claimHref, ctaLabel, onClaimClick }: ClaimCalloutProps) => (
  <section className={styles.section}>
    <div className={styles.content}>
      <div className={styles.copy}>
        <h2 className={styles.heading}>
          For contacts
          <br />
          that stay in contact
        </h2>
        <p className={styles.body}>
          Use Blinq to capture crucial context, spot opportunities, and turn a good meeting into
          brilliant business.
        </p>
        <div className={styles.actions}>
          <LandingButton href={claimHref} size="fluid" onClick={onClaimClick}>
            {ctaLabel}
          </LandingButton>
          <LandingButton href={BOOK_A_DEMO_HREF} tone="dark" size="fluid">
            Book a demo
          </LandingButton>
        </div>
      </div>
    </div>
    <div className={styles.media}>
      <img
        className={styles.image}
        src={CTA_IMAGE.src}
        width={CTA_IMAGE.width}
        height={CTA_IMAGE.height}
        alt=""
        loading="lazy"
      />
    </div>
  </section>
);
